import { render, staticRenderFns } from "./AllRightsReserved.vue?vue&type=template&id=58918020&scoped=true"
import script from "./AllRightsReserved.vue?vue&type=script&lang=js"
export * from "./AllRightsReserved.vue?vue&type=script&lang=js"
import style0 from "./AllRightsReserved.vue?vue&type=style&index=0&id=58918020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58918020",
  null
  
)

export default component.exports